import * as React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import useBanners from '../../../hooks/navigation/useBanners';
import { HAIRLINE } from './colors';

const HEADER_HEIGHT = 64;
const HEADER_HEIGHT_WITH_BANNER = 109;

export const DESKTOP_PROFILE_QUERY = '(min-width:1200px)';

interface Props {
  summary: React.ReactNode;
  children: React.ReactNode;
}

// Below desktop the summary lives in a Profile tab, so only the tabs render.
function CustomerProfileLayout({ summary, children }: Props) {
  const { isBannerShown } = useBanners();
  const isDesktop = useMediaQuery(DESKTOP_PROFILE_QUERY);
  const topOffset = isBannerShown ? HEADER_HEIGHT_WITH_BANNER : HEADER_HEIGHT;

  if (!isDesktop) {
    return (
      <Box
        component="main"
        sx={{
          padding: '24px 20px 56px',
          boxSizing: 'border-box',
        }}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        height: `calc(100dvh - ${topOffset}px)`,
        overflow: 'hidden',
      }}>
      <Box
        component="aside"
        sx={{
          width: 360,
          flexShrink: 0,
          height: '100%',
          overflowY: 'auto',
          borderRight: `1px solid ${HAIRLINE}`,
          padding: '24px 32px 56px',
          boxSizing: 'border-box',
        }}>
        {summary}
      </Box>
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          height: '100%',
          overflowY: 'auto',
          padding: '32px 48px 96px',
          maxWidth: 900,
          boxSizing: 'border-box',
        }}>
        {children}
      </Box>
    </Box>
  );
}

export default CustomerProfileLayout;
